module.exports = __webpack_public_path__ + "static/media/poppop-shop.a0f06e33.png";